import { Formik } from 'formik'
import React, { useCallback } from 'react'
import BrandForm from './BrandForm'
import { contactBrand } from 'services/api'
import { brandValidationSchema } from './validation'
import { navigate } from 'gatsby'
import {
  _captchaTypeInvisible,
  _startSellingOnFlip,
  _captchaToken,
  _captchaType,
  _isChallengeRequired,
  CAPTCHA_ERROR_CODES,
  _captchaTypeVisible,
} from 'constants/recaptcha'

import {
  _brandName,
  _email,
  _companyName,
  _sales,
  _genders,
  _categoryList,
  _countryOfOrigin,
  _description,
  _instagramUrl,
  _websiteUrl,
  _foundedInYear,
  _mainContactName,
  _mainContactPhone,
  _prefixContactPhone,
  _goals,
} from './config'

const recaptchaKey = process.env.RECAPTCHA_INVISIBLE_KEY

const Form = () => {
  const onSubmit = useCallback(async (values, actions) => {
    actions.setSubmitting(true)
    const salesData = values[_sales] === '' ? {} : { sales: values[_sales] }
    const recaptcha = window?.grecaptcha?.enterprise
    const requestData = {
      [_brandName]: values[_brandName],
      [_email]: values[_email],
      [_companyName]: values[_companyName],
      [_genders]: values[_genders],
      [_categoryList]: values[_categoryList],
      [_countryOfOrigin]: values[_countryOfOrigin],
      [_description]: values[_description],
      [_instagramUrl]: values[_instagramUrl],
      [_websiteUrl]: values[_websiteUrl],
      [_foundedInYear]: Number(values[_foundedInYear] || 0),
      [_mainContactName]: values[_mainContactName],
      [_mainContactPhone]: values[_mainContactPhone]
        ? `${values[_prefixContactPhone].trim()}${values[_mainContactPhone]}`
        : '',
      brandGoalsOnFlip: values[_goals] ? values[_goals] : null,
      ...salesData,
    }
    const isChallengeRequired = values[_isChallengeRequired]

    const onSuccess = ({ ok, data }) => {
      if (ok) {
        if (data && data.brandId) {
          navigate('/thank-you')
        } else {
          actions.setStatus({
            submitError: 'An error occurred, Please Try Again',
          })
        }
      } else {
        const errorCode = data.code

        if (isChallengeRequired) {
          const recaptcha = window?.grecaptcha?.enterprise

          recaptcha.reset()
        }

        if (
          errorCode === CAPTCHA_ERROR_CODES.SCORE_TOOL_LOW ||
          errorCode === CAPTCHA_ERROR_CODES.TOO_MANY_FAILED_LOGIN_ATTEMPTS
        ) {
          actions.setFieldValue(_isChallengeRequired, true)
        } else {
          const errorMessage =
            data && data.message
              ? data.message
              : 'An error occurred, Please Try Again'

          actions.setStatus({
            submitError: errorMessage,
          })
        }
      }
      actions.setSubmitting(false)
    }
    if (recaptcha && recaptchaKey) {
      if (isChallengeRequired) {
        await contactBrand(requestData, {
          [_captchaToken]: values[_captchaToken],
          [_captchaType]: _captchaTypeVisible,
        }).then(onSuccess)
      } else {
        recaptcha.ready(async () => {
          const invisibleRecaptchaToken = await recaptcha.execute(
            recaptchaKey,
            {
              action: _startSellingOnFlip,
            }
          )

          await contactBrand(requestData, {
            [_captchaToken]: invisibleRecaptchaToken,
            [_captchaType]: _captchaTypeInvisible,
          }).then(onSuccess)
        })
      }
    }
  }, [])

  return (
    <Formik
      initialValues={{
        [_brandName]: '',
        [_email]: '',
        [_companyName]: '',
        [_sales]: '',
        [_genders]: [],
        [_categoryList]: [],
        [_countryOfOrigin]: '',
        [_description]: '',
        [_instagramUrl]: '',
        [_websiteUrl]: '',
        [_foundedInYear]: '',
        [_mainContactName]: '',
        [_mainContactPhone]: '',
        [_prefixContactPhone]: '',
        [_goals]: [],
        [_isChallengeRequired]: true,
        [_captchaToken]: '',
      }}
      onSubmit={onSubmit}
      validationSchema={brandValidationSchema}
    >
      {props => <BrandForm {...props} />}
    </Formik>
  )
}

export default Form
